import React, { useEffect } from 'react';
import { Row, Col, Table, Input, InputNumber, Select, Button, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { validateRutHelper } from '../../../../../../../helpers';

const { Option } = Select;

const MallaPropiedadEditor = ({tempMalla, saving, onChangeUbo, onAddUbo, onRemoveUbo, onSave,
                                onCancel, forceExpand, currentUser, form, setValidateMalla }) => {
    const { t } = useTranslation()
    const { getFieldDecorator, validateFields } = form || {}

    useEffect(() => {
        if (setValidateMalla && validateFields) {
            setValidateMalla(validateFields)
        }
    }, [validateFields, setValidateMalla])

    useEffect(() => {
        if (!form || !form.validateFields || tempMalla.length === 0) return
        const fieldNames = tempMalla.map((_, i) => `participacion_${i}`)
        form.validateFields(fieldNames, { force: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tempMalla])

        const columns = [
        {
            title: `${t('messages.aml.rut')} *`,
            dataIndex: 'rut',
            render: (text, _record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    {getFieldDecorator && getFieldDecorator(`rut_${index}`, {
                        rules: [
                            { required: true, message: t('messages.validation.all.field.required') },
                            {
                                validator: (_, value, callback) => {
                                    const paisId = form.getFieldValue(`paisId_${index}`)
                                    if (value && paisId !== 2 && currentUser?.cliente?.pais === 'CHI' && !validateRutHelper(value)) {
                                        callback(t('messages.aml.errorRutInvalidoPN'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ],
                        initialValue: text
                    })(
                        <Input
                            style={{ width: '100%' }}
                            onChange={e => onChangeUbo(index, 'rut', e.target.value)}
                            maxLength={20}
                        />
                    )}
                </Form.Item>
            )
        },
        {
            title: `${t('messages.aml.name')} *`,
            dataIndex: 'name',
            render: (text, _record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    {getFieldDecorator && getFieldDecorator(`name_${index}`, {
                        rules: [{ required: true, message: t('messages.validation.all.field.required') }],
                        initialValue: text
                    })(
                        <Input
                            style={{ width: '100%' }}
                            onChange={e => onChangeUbo(index, 'name', e.target.value)}
                            maxLength={200}
                        />
                    )}
                </Form.Item>
            )
        },
        {
            title: `${t('messages.aml.participation')} *`,
            dataIndex: 'participacionDirecta',
            render: (text, _record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    {getFieldDecorator && getFieldDecorator(`participacion_${index}`, {
                        rules: [
                            { required: true, message: t('messages.validation.all.field.required') },
                            { type: 'number', min: 0, max: 100, message: t('messages.validation.required') }
                        ],
                        initialValue: text
                    })(
                        <InputNumber
                            min={0}
                            max={100}
                            step={0.01}
                            onChange={value => onChangeUbo(index, 'participacionDirecta', value)}
                        />
                    )}
                </Form.Item>
            )
        },
        {
            title: t('messages.aml.citizenship'),
            dataIndex: 'paisId',
            render: (text, _record, index) => (
                <Form.Item style={{ marginBottom: 0 }}>
                    {getFieldDecorator && getFieldDecorator(`paisId_${index}`, {
                        initialValue: text != null ? Number(text) : 1
                    })(
                        <Select style={{ width: '100%' }} onChange={value => {
                            onChangeUbo(index, 'paisId', value)
                            form.validateFields([`rut_${index}`], { force: true })
                        }}>
                            <Option value={1}>{t('messages.aml.national')}</Option>
                            <Option value={2}>{t('messages.aml.foreign')}</Option>
                        </Select>
                    )}
                </Form.Item>
            )
        },
        {
            title: t('messages.aml.differences'),
            dataIndex: 'error',
            render: (error) => {
                if (error !== undefined && error !== null) {
                    return {
                        props: { className: 'error-' + error.code },
                        children: <div className="nowrap">{ t('messages.aml.malla.error' + error.code) }</div>                    }
                }
            }
        },
        {
            title: '',
            key: 'actions',
            width: 50,
            render: (_text, _record, index) => (
                <Button
                    type="primary"
                    icon="close"
                    size="small"
                    onClick={() => onRemoveUbo(index)}
                />
            )
        }
    ]

    return (
        <Form>
            <Row style={{ marginTop: 20, marginBottom: 10 }} type="flex" justify="end" align="middle">
                <Col>
                    <Button onClick={onCancel} disabled={saving} style={{ marginRight: 8 }}>
                        {t('messages.aml.cancel')}
                    </Button>
                    <Button type="primary" icon="save" onClick={onSave} loading={saving}>
                        {t('messages.aml.save')}
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        className="tbl-related"
                        dataSource={tempMalla.map((u, i) => ({ ...u, key: i }))}
                        columns={columns}
                        pagination={!forceExpand && tempMalla.length > 10}
                        size="small"
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={24}>
                    <Button
                        type="primary"
                        icon="plus"
                        size="small"
                        onClick={onAddUbo}
                        disabled={saving}
                        className="btn-add-replegal"
                    >
                        {t('messages.aml.addUbo')}
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}

export default Form.create({ name: 'malla_form' })(MallaPropiedadEditor);
